<div class="refFrame">
  <a
    [href]="image().link"
    target="_blank"
    style="display: flex; align-self: center"
  >
    <img class="logo" [src]="image().src" [alt]="image().alt"
  /></a>
  <p class="fade">
    {{ "ref.from" | translate }}
    <span class="black">{{ company() }}</span>
  </p>
  <p class="fade">{{ "ref.scope" | translate }}<br /></p>
  <ng-content />
  <a class="bold" target="_blank" [href]="pdf()"
    >{{ "ref.see" | translate }} →</a
  >
</div>
